import { Person } from '~/layers/forms/models/index'

export type Customer = Person

function load(model?: Partial<Customer> | null): Customer {
  return Person.load(model)
}

export const CustomerTypeEnum = {
  Person: { label: 'Persona', code: 'Person' },
  Business: { label: 'Empresa', code: 'Business' },
} as const

function getCustomerTypeList() {
  return Object.values(CustomerTypeEnum)
}

export const Customer = {
  load,
  getCustomerTypeList,
}
